import type {
  MiniAppAccountChoiceResponse,
  MiniAppAuthResponse,
  SignInCompletedResponse,
} from '@repo/api/web/models'

export type MiniAppAuthOutcome
  = | { kind: 'completed', session: SignInCompletedResponse }
    | { kind: 'accountChoice', choice: MiniAppAccountChoiceResponse }

/**
 * Narrows `MiniAppAuthResponse` (completed | accountChoice) for exhaustive handling.
 */
export function resolveMiniAppAuthResponse(
  response: MiniAppAuthResponse,
): MiniAppAuthOutcome {
  const completed = response.completed
  if (completed?.token) {
    return { kind: 'completed', session: completed }
  }

  const choice = response.accountChoice
  if (choice?.token && Array.isArray(choice.accounts) && choice.accounts.length > 0) {
    return { kind: 'accountChoice', choice }
  }

  throw new Error('Unexpected MiniAppAuthResponse: neither completed nor accountChoice')
}
